import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";
import Checker from "@/models/Checker";

interface GetWorkersParams {
  skip: number;
  limit: number;
  q: string;
  name: string;
  email: string;
  phone: string;
}
export default class RestResourceChecker {
  getCheckers(params: GetWorkersParams) {
    return getAPI.get(`api/rest/v1/user`, { params });
  }
  getChecker(id: string) {
    return getAPI.get(`api/rest/v1/user/${id}`);
  }
  putChecker(id: string, body: Checker) {
    return getAPI.put(`api/rest/v1/user/${id}`, body);
  }
}
